"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.LogLevel = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const util_1 = require("./util");
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["None"] = 1] = "None";
    LogLevel[LogLevel["Critical"] = 2] = "Critical";
    LogLevel[LogLevel["Error"] = 3] = "Error";
    LogLevel[LogLevel["Warn"] = 4] = "Warn";
    LogLevel[LogLevel["Info"] = 5] = "Info";
    LogLevel[LogLevel["Trace"] = 6] = "Trace";
    LogLevel[LogLevel["Debug"] = 7] = "Debug";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
const logLevelNames = ["NULL", "NONE", "CRITICAL", "ERROR", "WARNING", "INFO", "TRACE", "DEBUG"];
class Logger {
    constructor(name, level) {
        this.name = name;
        this.level = level || LogLevel.Debug;
    }
    err(msg) {
        this.log(LogLevel.Error, msg);
    }
    warn(msg) {
        this.log(LogLevel.Warn, msg);
    }
    info(msg) {
        this.log(LogLevel.Info, msg);
    }
    trace(msg) {
        this.log(LogLevel.Trace, msg);
    }
    debug(msg) {
        this.log(LogLevel.Debug, msg);
    }
    log(level, msg) {
        if (level <= this.level) {
            console.log(`${util_1.Util.formatNow()} ${logLevelNames[level]} ${this.name} ${msg}`);
        }
    }
}
exports.Logger = Logger;
